export const globals = {
  uid: 1,
  key: 'be80d8b4-f4e1-4d4c-82e5-988eb991bd51',
  api: 'https://api.glassfactoryapp.com/api/v2/',
  cdn: 'https://glassfactoryapp.s3.eu-west-1.amazonaws.com/',
  platform: 'Android', // Web // iOS // Android
  version: '2.4.9',
  server: 'Live' // Live // Dev
};